/* eslint-disable camelcase */
import swal from 'sweetalert2'
import router from '../../router/router'
import { resetStateToDefault } from '../../utils'
import { configureCongito } from './cognito'
import { Http } from 'vue-resource'
import { gerarUrlLogin, gerarUrlRegisterCognito } from '../../api'
import i18n from '../../locales/i18n'
import * as Sentry from '@sentry/vue'
import { formatarObjetoWebParaSentry } from '../../sentry.ts'

function defaultState () {
  return {
    email: '',
    password: '',
    token: '',
    mostrarInput: 'email',
    logando: false,

    cognitoInfo: {
      accessToken: null,
      userPoolId: null,
      useCognito: null,
      userPoolWebClientId: null
    }
  }
}

const mutations = {
  resetState (state) {
    resetStateToDefault(state, defaultState())
  },
  email (state, email) {
    state.email = email
  },
  password (state, password) {
    state.password = password
  },
  logando (state, logando) {
    state.logando = logando
  },
  atribuiMostrarInput (state, mostrarInput) {
    state.mostrarInput = mostrarInput
  },
  atribuiToken (state, token) {
    state.token = token
  }
}

const actions = {
  async realizarLogin ({ commit, state, dispatch }) {
    const credenciais = { username: state.email, password: state.password }
    commit('logando', true)
    try {
      const response = await Http.post(gerarUrlLogin(), credenciais)
      const { access_token } = response.body
      commit('regularToken', access_token, {root: true})
      commit('email', '')
      commit('password', '')
      dispatch('coletor/buscarColetores', {}, {root: true})
    } catch (e) {
      commit('logando', false)
      if (e.status === 400) {
        swal({ type: 'error', title: i18n.t('componentes.register.state.naoAutorizado.titulo'), text: i18n.t('componentes.register.state.naoAutorizado.texto'), allowEnterKey: false })
          .then(result => {
            commit('atribuiMostrarInput', 'email')
            commit('password', '')
          })
        return
      }
      swal({ type: 'error', text: i18n.t('componentes.register.state.erroNoLogin.texto') })
      commit('atribuiMostrarInput', 'email')
      commit('password', '')
    }
  },
  async registerWithLogin ({ state, dispatch, rootState, commit }) {
    let userPoolId = null; let userPoolWebClientId = null; let useCognito = null

    if (rootState.accessData.cognitoInfo) {
      userPoolId = rootState.accessData.cognitoInfo.userPoolId
      userPoolWebClientId = rootState.accessData.cognitoInfo.userPoolWebClientId
      useCognito = rootState.accessData.cognitoInfo.useCognito
    }

    if (state.email.length < 3 || state.password.length < 4) {
      swal({ type: 'info', text: i18n.t('componentes.register.state.emailOuSenhaInvalido.texto') })
      return
    }

    if (useCognito && userPoolId && userPoolWebClientId) {
      commit('logando', true)
      let cognitoUser

      try {
        configureCongito({ userPoolId, userPoolWebClientId })
        // eslint-disable-next-line no-undef
        cognitoUser = await Auth.signIn(state.email, state.password)
      } catch (e) {
        commit('logando', false)
        console.warn('Login into cognito failed. Using legacy authentication')
      }

      if (cognitoUser) {
        dispatch('executeRegister', {
          cognitoInfo: {
            accessToken: 'Bearer ' + cognitoUser.signInUserSession.idToken.jwtToken,
            userPoolId,
            userPoolWebClientId
          }
        })
      } else {
        dispatch('executeRegister', {
          email: state.email,
          password: state.password
        })
      }
    } else {
      dispatch('executeRegister', {
        email: state.email,
        password: state.password
      })
    }
  },
  async executeRegister ({ commit, dispatch }, { cognitoInfo = null }) {
    try {
      if (cognitoInfo) {
        commit('cognitoInfo', cognitoInfo, {root: true})
        await Http.post(gerarUrlRegisterCognito()) // resource will resolve the headers
        dispatch('coletor/buscarColetores', {}, {root: true})
      } else {
        dispatch('realizarLogin')
      }
    } catch (erro) {
      const ipNaoAutorizado = erro.status === 403 && erro.bodyText === 'Esse ip não está autorizado para fazer requisições'
      if (!ipNaoAutorizado) {
        await swal({ type: 'error', text: erro && erro.body && erro.body.error ? erro.body.error : i18n.t('componentes.register.state.codigoInvalido.texto') })

        Sentry.captureEvent({
          message: 'Executando registro, ip não autorizado (clear)',
          contexts: {
            localStorage: {
              web: formatarObjetoWebParaSentry(window.localStorage.getItem('web'))
            }
          }
        })
        router.push({name: 'clear'})
      }
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  actions,
  mutations
}
